<script setup lang="ts">
// Root of the shared dropdown menu (Reka DropdownMenu). Supports v-model:open
// so callers keep driving their existing reactive flag; omit it for an
// uncontrolled menu. Reka owns outside-click, Escape, roving focus, type-ahead
// and aria - replacing the hand-rolled document listeners both apps carried.
import { DropdownMenuRoot } from 'reka-ui';

defineProps<{ open?: boolean | undefined }>();
defineEmits<{ (e: 'update:open', value: boolean): void }>();
</script>

<template>
  <DropdownMenuRoot :open="open" @update:open="$emit('update:open', $event)">
    <slot />
  </DropdownMenuRoot>
</template>
